import '../vil/jquery.vil';

// Add uScope extensions
import '../vil/uScope-extensions/vil-wrapper';
import '../vil/uScope-extensions/resize-viewer';



// WEBPACK FOOTER //
// ./src/lib/vil.js